export default {"src":"/_next/static/media/loader.4d933f1a.gif","height":300,"width":400,"blurWidth":0,"blurHeight":0};